<template>
  <div id="qrcode-wrap">
    <div>
      <div class="qrcode" ref="qrCodeUrl"></div>
      <h3>用谷歌验证器绑定后-返回页面，重新登录</h3>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex'
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {
        text: this.$route.params.text,
      }
    },
    methods: {
      creatQrCode() {
        new QRCode(this.$refs.qrCodeUrl, {
          text: this.text,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    mounted() {
      this.creatQrCode();

    },
  }

</script>
<style>
  #qrcode-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
  }

  #qrcode-wrap>div {
    text-align: center;
    position: relative;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
  }

  .qrcode {
    text-align: center;
  }

  .qrcode img {
    margin: 0 auto;
    padding: 20px;
    background-color: white;
  }

  #qrcode-wrap h3 {
    color: wheat;
    margin-top: 20px;
    font-size: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/components/utils/qrCode.vue